export const SECTIONS = [
  "session_report",
  "active_users",
  "device_report",
  "users_report",
  "exp_report",
  "ad_report",
  "booking_transactions",
  "products_subscriprions_transactions",
  "form_builder_transactions",
]
